export default __webpack_public_path__ + "static/media/logo_ulagos.829e951d.png";